/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_SummaryInputs */



/**
* | output |
* | --- |
* | "Notifications after your conversation" |
*
* @param {Notifications_SummaryInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const notifications_summary = /** @type {((inputs?: Notifications_SummaryInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_SummaryInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Meldingen na je gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notifications après votre conversation")
	return /** @type {LocalizedString} */ ("Notifications after your conversation")
});